import { render } from "./cemsPublicityTiny.vue?vue&type=template&id=18ac3776&scoped=true"
import script from "./cemsPublicityTiny.vue?vue&type=script&lang=js"
export * from "./cemsPublicityTiny.vue?vue&type=script&lang=js"

import "./cemsPublicityTiny.vue?vue&type=style&index=0&id=18ac3776&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ac3776"]])

export default __exports__